import React, { useId, useState } from 'react';
import { DetailsPanelContainer } from './styles';
import { ReactComponent as ChevronDownIcon } from '../../../../assets/chevron-down.svg';

interface Props {
  title: React.ReactNode;
  summary?: React.ReactNode;
  footer?: React.ReactNode;
  children: React.ReactNode;
}

const DetailsPanel = ({ title, summary, footer, children }: Props) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const id = useId();

  return (
    <DetailsPanelContainer>
      <h3 className='panel-heading'>
        <button
          type='button'
          id={`${id}-trigger`}
          aria-expanded={isExpanded}
          aria-controls={`${id}-content`}
          onClick={() => setIsExpanded((value) => !value)}>
          <span>{title}</span>
          <span
            className='panel-chevron'
            aria-hidden='true'>
            <ChevronDownIcon />
          </span>
        </button>
      </h3>
      <div
        id={`${id}-content`}
        className='panel-region'
        data-expanded={isExpanded}
        aria-hidden={!isExpanded}
        {...(!isExpanded ? { inert: '' } : {})}
        aria-labelledby={`${id}-trigger`}>
        <div className='panel-region-inner'>
          <div className='panel-content'>{children}</div>
        </div>
      </div>
      {summary && (
        <div
          className='panel-region'
          data-expanded={!isExpanded}
          aria-hidden={isExpanded}
          {...(isExpanded ? { inert: '' } : {})}>
          <div className='panel-region-inner'>
            <div className='panel-summary'>{summary}</div>
          </div>
        </div>
      )}
      {footer && <div className='panel-footer'>{footer}</div>}
    </DetailsPanelContainer>
  );
};

export default DetailsPanel;
